import script from "./Remarks.vue?vue&type=script&async=true&setup=true&lang=js"
export * from "./Remarks.vue?vue&type=script&async=true&setup=true&lang=js"

import "./Remarks.vue?vue&type=style&index=0&id=e2614804&lang=css"

const __exports__ = script;

export default __exports__